import React from 'react';
import ProtectedRoute from '../components/RouteHelpers/ProtectedRoute/ProtectedRoute';
import SuccessPayment from '../components/RouteHelpers/SuccessPayment/SuccessPayment';
import useSessionStore from '../stores/useSessionStore';

export default function PaymentSuccessProtected() {
  const user = useSessionStore((s) => s.user);
  return (
    <ProtectedRoute
      isAllowed={!user?.isAllNotAdmin}
      pathRedirect="/projects-new"
    >
      <SuccessPayment />
    </ProtectedRoute>
  );
}
